import React, { useEffect, useRef } from 'react';
import { fireImpressionEvent } from '../../Utils/StoreHomePageUtils';

const ScrollWrapper = (props) => {
  const { data, contentDisplay, outerRef } = props;

  const createObserver = function (handleIntersection, options, element) {
    const observer = new IntersectionObserver(handleIntersection, options);
    observer.observe(element);
    return observer;
  };

  const sectionRef = useRef();
  useEffect(() => {
    if (props.children) {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: [],
      };
      const element = outerRef?.current || sectionRef?.current;
      const callback = (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // if (product_id === 979) fireImpressionEvent(data);
            // else if (!product_id) fireImpressionEvent(data);
            if (data) fireImpressionEvent(data);
            observer.unobserve(element);
          }
        });
      };
      const observer = createObserver(callback, options, element);
      return () => {
        observer.unobserve(element);
      };
    }
  }, []);
  return contentDisplay ? (
    <>{props.children}</>
  ) : (
    <div ref={sectionRef}>{props.children}</div>
  );
};

export default ScrollWrapper;
